<template>
	<div class="pay">
		<div class="pay_header">
			<span @click="goBack()">
				<img src="../../../static/images/back.png">
				<i v-if="isScan">加菜</i>
			</span>
    		<h2 v-if="model != 3">{{tabName}}</h2>
    		<p v-if="oldCartList.length > 0" @click="$router.push({path: '/details'})">详情</p>
    		<p v-if="openid && isScan && (model == 0 || model == 3)" @click="showInfo">订单</p>
		</div>
		<div class="pay_info" :style="model == 3 ? 'height:10vh' : ''">
			<div class="info_list" v-if="isScan">
				<label>所属门店</label>
				<h4>{{shopName}}</h4>
			</div>
			<div class="info_list" v-if="!isScan">
				<label>桌台名称</label>
				<h4 @click="goSelectTab()">{{tabName}}<img src="../../../static/images/next.png" alt="" /></h4>
			</div>
			<div class="info_list" v-else-if="model != 3">
				<label>桌台名称</label>
				<h4>{{tabName}}</h4>
			</div>
			<div class="info_list">
				<label>就餐人数</label>
	        	<h4 @click="eatNumFn">{{eatNum}}</h4>
					<!-- <input type="number" placeholder="就餐人数" v-model="eatNum" @focus="focus($event)" /> -->
			</div>
			<div class="info_list" v-if="!isScan">
				<label>员工编号</label>
				<input type="number" placeholder="员工编号" v-model="memberCode" @focus="focus($event)" @blur.prevent="changeMCode()" disabled />
			</div>
		</div>

	    <!-- 扫码点餐输入数量弹窗 -->
	    <div class="format" v-if="numShow">
	      <div class="format_content" @click.stop>
	        <div class="format_header">
	          <h2>选择就餐人数</h2>
	          <p @click="selectNum">选择</p>
	        </div>
	        <div class="format_content_num" @scroll="handlerScroll">
	          <p :class="{active:i==eatNum}" v-for="(i, index) in 20" :key="index" @click="eatNum=i">{{i}}</p>
	        </div>
	      </div>
	    </div>

		<div class="pay_content" :style="model == 3 ? 'max-height: 68vh' : ''">
			<h2 v-show="newCartList.length>0">新点的菜</h2>
			<div class="content_list newCartList" v-for="(i, index) in newCartList">
				<div class="list_img">
					<viewer :images="[{ url: imguri + '/foodimage/png/' + i.foodimage, title: i.remark }]">
						<img :src="imguri + '/foodimage/png/' + (i.foodimage || 'LOGO.jpg')" alt="图片"/>
					</viewer>
				</div>
				<div class="list_info">
					<div class="clearFix">
						<p>
							<b v-if="i.canteenStatus>=0">[{{statusList[i.canteenStatus].name}}]</b>
							{{i.foodName}}
							<span style="color: red" v-if="i.givefoodnumber>0">[赠{{i.givefoodnumber}}]</span>
							<span style="color: red" v-if="i.returnfoodnumber>0">[退{{i.returnfoodnumber}}]</span>
						</p>
						<span>/x{{i.qty | capitalize}}&nbsp;{{i.unit}}</span>
					</div>
					<p style="color:#333;font-size: 12px;" v-if="i.remark && i.remark.length != 0">
            ( <span v-for="(j, index2) in i.remark"> {{j.name}} </span> )
          </p>
					<p style="color:#333;font-size: 12px;" v-else-if="i.setMealItems && i.setMealItems.length != 0">
						( <span v-for="(j, index2) in i.setMealItems"> {{j.foodName}} </span> )
					</p>

					<div class="div_i_span" v-if="!isScan" @click="getFoodFn(i, 1, index)">
						<i class="el-icon-edit-outline"></i>
						<span style="color: #ffa500;">操作</span>
					</div>
				</div>
				<h4 class="list_money">
					<span>￥{{i.allMoney}}</span>
					<el-button size="mini" @click="getTaste(i, index)">口味</el-button>
				</h4>
			</div>

			<h2 v-show="oldCartList.length>0">已点的菜</h2>
			<div class="content_list" v-for="(i, index) in oldCartList">
				<div class="list_img">
					<viewer :images="[{ url: imguri + '/foodimage/png/' + i.foodimage, title: i.remark }]">
						<img :src="imguri + '/foodimage/png/' + (i.foodimage || 'LOGO.jpg')" alt="图片"/>
					</viewer>
				</div>
				<div class="list_info">
					<div class="clearFix">
						<em>
							<b v-if="i.canteenStatus>=0">[{{statusList[i.canteenStatus].name}}]</b>
							{{i.foodName}}
							<span style="color: red" v-if="i.givefoodnumber>0">[赠{{i.givefoodnumber}}]</span>
							<span style="color: red" v-if="i.returnfoodnumber>0">[退{{i.returnfoodnumber}}]</span>
						</em>
						<span>/x{{i.qty}}&nbsp;{{i.unit}}</span>
					</div>
					<p style="color:#ccc" v-if="i.remark && i.remark.length != 0">( <span v-for="(j, index2) in i.remark"> {{j.name}} </span> )</p>
					<p style="color:#ccc" v-else-if="i.setMealItems && i.setMealItems.length != 0">
            ( <span v-for="(j, index2) in i.setMealItems"> {{j.foodName}} </span> )
          </p>

					<div class="div_i_span" v-if="!isScan" @click="getFoodFn(i, 2, index)">
						<i class="el-icon-edit-outline"></i>
						<span style="color: #ffa500;">操作</span>
					</div>
				</div>
				<h4 class="list_money">￥{{i.allMoney}}</h4>
			</div>
		</div>
		<div class="note">
			<el-input type="text" placeholder="整单备注" v-model="remarks" @focus="focus($event)" clearable></el-input>
		</div>

		<!-- 底部按钮 -->
		<div class="pay_footer" v-if="!isScan">
			<div class="pay_money" v-if="cashPledge<=0">
				合计：<span>￥{{allMoney}}</span>
			</div>
			<div class="pay_money2" v-else>
				<p class="allMoney">合计：<span>￥{{allMoney}}</span></p>
				<p class="cashPledge" v-if="cashPledge > 0 && cashPledge">押金：<span>￥{{cashPledge}}</span></p>
			</div>
			<div class="pay_operate">
				<h4 @click="goPay(4)">立即支付</h4>
				<h4 @click="goPay(2)">提交订单</h4>
			</div>
		</div>
		<div class="pay_footer" v-else>
			<div class="pay_money" v-if="cashPledge<=0">
				合计：<span>￥{{allMoney}}</span>
			</div>
			<div class="pay_money2" v-else>
				<p class="allMoney">合计：<span>￥{{allMoney}}</span></p>
			</div>
			<div class="pay_operate" v-if="model == 0 || model == 3">
				<h4 @click="scanFn(1)">立即支付</h4>
			</div>
			<div class="pay_operate" v-else>
				<h4 @click="scanFn(1)" v-if="model == 1 && modelPay == 1 || model == 2 && modelPay == 1 && newCartList.length==0 ">立即支付</h4>
				<h4 @click="scanFn(2)">提交订单</h4>
			</div>
		</div>
		<!--
			扫码点餐 model
			0：客户扫码点餐后，支付后下单
			1：客户扫码点餐后，直接下单，消费后再支付
			2：客户扫码点餐后，服务员在PC端确认后再下单，消费后支付
			3：客户扫码点餐后，使用模式model=0的支付模式，支付成功后跳转至模拟小票页面
		-->

		<!-- 获取口味弹窗 -->
		<div class="taste_popUps" v-if="tasteFlag" @click="tasteFlag=false">
			<div class="taste_content" @click.stop>
				<h2  class="taste_title">
					<span>选择口味</span>
					<i class="el-icon-close" @click="tasteFlag=false"></i>
				</h2>
				<div  class="taste_list">
					<p v-for="(i, index) in tasteList" :class="{selectBor:i.isSelected}" @click="selectBtn(i)">
						{{i.title}}
						<span v-if="i.costFee>0"> +{{i.costFee}}</span>
					</p>
				</div>
				<div class="taste_bottom">
					<div class="taste_bottom_customize" v-if="!isScan">
						<el-input v-model="tasteName" placeholder="口味名称" @focus="focus($event)" @keyup.enter.native="customizeTaste" clearable>
							<el-button slot="append" @click="customizeTaste">确认</el-button>
						</el-input>
					</div>
					<div class="taste_btn" :style="isScan ? 'flex: 1' : ''">
						<el-button @click="determineTaste()">确定</el-button>
					</div>
				</div>
			</div>
		</div>

		<!-- 菜品状态修改 -->
		<div class="taste_popUps" v-if="optShow && !isScan" @click="optShow=false">
			<div class="taste_content" @click.stop>
				<h2  class="taste_title">
					<span>{{optFood.foodName}}</span>
					<i class="el-icon-close" @click="optShow=false"></i>
				</h2>
				<div  class="taste_otherOpt clearFix">
					<el-button icon="el-icon-edit" size="small" @click="editFn(2)">价格</el-button>
					<el-button icon="el-icon-edit" size="small" @click="editFn(3)" v-if="optFood.isNew == 1">数量</el-button>
					<el-button icon="el-icon-edit" size="small" @click="editFn(4)">折扣</el-button>
					<el-button icon="el-icon-edit" size="small" @click="editFn(5)">赠送</el-button>
					<el-button icon="el-icon-edit" size="small" @click="editFn(6)" v-if="optFood.isNew == 2">退菜</el-button>
					<el-button size="small" @click="discountFn()" v-if="optFood.isNew == 1">折扣方案</el-button>
				</div>
				<div  class="taste_item">
					<span v-if="optFood2.isNew == 1">
						<el-radio v-model="optFood.canteenStatus" label="0" key="0" :disabled="optFood2.canteenStatus != 0">新品</el-radio>
					</span>
					<span v-if="optFood2.isNew == 1 || optFood2.canteenStatus == 1">
						<el-radio v-model="optFood.canteenStatus" label="1" key="1">不厨打</el-radio>
					</span>
					<span v-if="optFood2.isNew == 1 || optFood2.canteenStatus == 1 || optFood2.canteenStatus == 2">
						<el-radio v-model="optFood.canteenStatus" label="2" key="2">厨打</el-radio>
					</span>
					<span v-if="optFood2.isNew == 1 || optFood2.canteenStatus == 3">
						<el-radio v-model="optFood.canteenStatus" label="3" key="3">等叫</el-radio>
					</span>
					<span v-if="optFood2.isNew == 1 || optFood2.canteenStatus == 3 || optFood2.canteenStatus == 4">
						<el-radio v-model="optFood.canteenStatus" label="4" key="4">叫起</el-radio>
					</span>
					<span v-if="optFood2.isNew != 1 && optFood2.canteenStatus != 6 && optFood2.canteenStatus != 7">
						<el-radio v-model="optFood.canteenStatus" label="5" key="5">催菜</el-radio>
					</span>
					<span v-if="optFood2.isNew != 1 && optFood2.canteenStatus != 7">
						<el-radio v-model="optFood.canteenStatus" label="6" key="6">划菜</el-radio>
					</span>
					<span v-if="optFood2.isNew != 1">
						<el-radio v-model="optFood.canteenStatus" label="7" key="7" disabled>退菜</el-radio>
					</span>
				</div>
				<div class="taste_btn">
					<el-button @click="optConfirm()">确&nbsp;&nbsp;定</el-button>
				</div>
			</div>
		</div>

		<!-- 折扣方案 -->
		<div class="taste_popUps" v-if="discountShow"  @click="discountShow=false">
			<div class="taste_content" @click.stop>
				<h2  class="taste_title">
					<span>{{optFood.foodName}}</span>
					<i class="el-icon-close" @click="discountShow=false"></i>
				</h2>
				<div class="taste_plan">
					<div class="taste_item" v-for="(i, index) in discountPlan" v-if="i.list.length > 0">
						<h2>{{i.name}}</h2>
						<div class="taste_item_list" v-for="(e, eIndex) in i.list" @click="selectPromotion=e.id">
							<div>
								<el-radio v-model="selectPromotion" :label="e.id" :key="e.id"></el-radio>
							</div>
							<h6 v-if="i.type == 0">买</h6>
							<h6 v-else-if="i.type == 1">买</h6>
							<h6 v-else-if="i.type == 2">买</h6>
							<p>{{e.value1}}</p>
							<h6 v-if="i.type == 0">，送</h6>
							<h6 v-else-if="i.type == 1 || i.type == 2">件，</h6>
							<p>{{e.value2}}</p>
							<h6 v-if="i.type == 1 || i.type == 2">折</h6>
						</div>
					</div>
				</div>
				<div class="taste_btn">
					<el-button @click="discountShow=false">取消</el-button>
					<el-button @click="confirmDiscount">确定</el-button>
				</div>
			</div>
		</div>

		<div class="member_popUps" v-if="payShow" @click="hidePay">
			<div class="member_wrap" @click.stop>
				<h2>订单结算</h2>
				<div class="member_content">
					<div class="member_img">
						<img :src="imguri + (memberInfo.headImage ? '/memberImages/' + memberInfo.headImage : '/foodimage/png/LOGO.jpg')"
							@click="getMember" v-if="memberInfo.memberId"/>
						<i class="el-icon-s-custom" @click="getMember" v-else></i><span>点击搜索</span>
					</div>
					<div class="member_info">
						<h6><i class="el-icon-s-custom"></i>名称：{{memberInfo.memberName || '--'}}</h6>
						<p><i class="el-icon-s-finance"></i>余额：￥{{memberInfo.balanceAmount || 0}}</p>
						<p><i class="el-icon-s-opportunity"></i>积分：{{memberInfo.surplusIntegral || 0}}分</p>
					</div>
					<div class="member_close" @click="clearInfoFn" v-if="memberInfo.memberId"><i class="el-icon-close"></i></div>
					<div class="member_wrap_newAdd" @click="addMember" v-else-if="!isScan">新增会员</div>
				</div>
				<div class="member_pay">
					<div>
						<h6>应付金额：</h6>
						<p>￥{{allMoney}}</p>
					</div>
					<div>
						<h6>优惠金额：</h6>
						<p><span v-if="discountMoney > 0">-</span>￥{{discountMoney}}</p>
					</div>
					<div v-if="teaFee>0">
						<h6 style="width: 90px;">服务费({{curClickInfo.teaFee}}%)：</h6>
						<p>￥{{teaFee}}</p>
					</div>
					<div>
						<h6>实付金额：</h6>
						<h5>￥{{payMoney}}</h5>
					</div>
					<div v-if="!isScan">
						<h6>折扣优惠：</h6>
						<p>
							<span><el-radio v-model="manualType" label="0" @change="typeChange">正价</el-radio></span>
							<span><el-radio v-model="manualType" label="1" @change="typeChange">优惠</el-radio></span>
							<span><el-radio v-model="manualType" label="2" @change="typeChange">折扣</el-radio></span>
						</p>
					</div>
					<div class="member_verify" v-if="!isScan && manualType==1">
						<h6>手动优惠：</h6>
						<p>
							<el-input type="number" v-model="manualOffer" placeholder="手动优惠价格" @focus="focus($event)" clearable></el-input>
						</p>
						<h3 v-if="manualOffer && manualOffer > userInfo.userThronesEntity.privilege">
							手动优惠上限为：￥{{userInfo.userThronesEntity.privilege}}
						</h3>
					</div>
					<div v-if="manualType==1 && manualOffer">
						<h6 style="width: 100px;">优惠后金额：</h6>
						<h5>￥{{((payMoney*100 - manualOffer*100)/100).toFixed(2)}}</h5>
					</div>
					<div class="member_verify" v-if="!isScan && manualType==2">
						<h6>手动折扣：</h6>
						<p>
							<el-input type="number" v-model="manualDiscount" placeholder="数字 80：8折优惠，100：不打折" @focus="focus($event)" clearable></el-input>
						</p>
						<h3 v-if="manualDiscount && manualDiscount < userInfo.userThronesEntity.discount">
							手动折扣下限为：{{userInfo.userThronesEntity.discount}}折
						</h3>
					</div>
					<h5 v-if="shopSetInfo.isSendVerificationCode == 0 && memberInfo.password && memberInfo.balanceAmount >= payMoney">
						会员支付时请选择一种验证方式：
					</h5>
					<div v-if="manualType==2 && manualDiscount">
						<h6 style="width: 100px;">折扣后金额：</h6>
						<h5>￥{{((payMoney*manualDiscount)/100).toFixed(2)}}</h5>
					</div>
					<div class="member_verify"
						v-if="shopSetInfo.isSendVerificationCode == 0 && memberInfo.password && memberInfo.balanceAmount >= payMoney">
						<h6>密码：</h6>
						<p>
							<el-input type="password" v-model="password" placeholder="会员支付密码" @focus="focus($event)" clearable></el-input>
						</p>
					</div><!--//0：其他，1：验证码，2：密码-->
					<div class="member_verify"
						v-if="(shopSetInfo.isSendVerificationCode == 1 || memberInfo.password) && memberInfo.balanceAmount >= payMoney">
						<h6>验证码：</h6>
						<p>
							<el-input type="number" v-model="code" placeholder="验证码" @focus="focus($event)" clearable>
								<el-button slot="append" @click="getCodeFn" v-if="time==0">点击获取</el-button>
								<el-button slot="append" v-else>{{time}}s</el-button>
							</el-input>
						</p>
					</div>
				</div>

				<div class="member_btn" v-if="!isScan"><!-- 0：微信，1：会员，2：支付宝 -->
					<el-button @click="hidePay">取消</el-button>
					<el-button @click="goPay(1, '1')" v-if="memberInfo.balanceAmount >= payMoney">会员余额</el-button>
					<el-button @click="goPay(1, '0')">{{shopInfo.payConfig == 4 ? '微信' : '在线支付'}}</el-button>
					<el-button @click="goPay(1, '2')" v-if="shopInfo.payConfig == 4">支付宝</el-button>
					<el-button @click="otherPayFn">其他支付</el-button>
					<div class="member_btn_other clearFix" v-if="otherPay">
						<div @click="morePayFn(3)">
							<img src="../../../static/images/cash.png"/>
							<p>现金支付</p>
						</div>
						<div @click="morePayFn(4)">
							<img src="../../../static/images/UnionPay.png"/>
							<p>银联支付</p>
						</div>
						<div @click="morePayFn(5)" v-if="shopSetInfo.isOpenPointCredit == 1 && memberInfo.memberId">
							<img src="../../../static/images/integral.png"/>
							<p>积分抵现</p>
						</div>
						<div @click="otherOffPay=!otherOffPay" v-if="currencyList.length > 0">
							<img src="../../../static/images/other.png"/>
							<p>其他币种</p>
						</div>
					</div>
					<div class="member_btn_other2 clearFix" v-if="otherOffPay">
						<!--<div v-for="(i, index) in currencyList" @click="morePayFn(6, i)" v-if="i.isdefault != 0">-->
						<div v-for="(i, index) in currencyList" @click="morePayFn(6, i)">
							<p>{{i.name}}</p>
							<p>汇率：{{i.exchange}}</p>
						</div>
					</div>
				</div>
				<div class="member_btn" v-else>
					<el-button @click="payShow=false">取消</el-button>
					<el-button @click="scanFn(1, '1')" v-if="memberInfo.balanceAmount >= payMoney">会员支付</el-button>
					<el-button @click="scanFn(1, '0')">在线支付</el-button>
				</div>
			</div>
		</div>

		<div class="member_popUps" v-if="otherPayWindow" @click="otherPayWindow=false">
			<div class="member_wrap" @click.stop>
				<h2 v-if="selectCurrency.payType == 3">现金支付</h2>
				<h2 v-else-if="selectCurrency.payType == 4">银联支付</h2>
				<h2 v-else-if="selectCurrency.payType == 5">积分抵现</h2>
				<h2 v-else>其他结算</h2>
				<div class="member_pay">
					<div>
						<h6>应付金额：</h6>
						<p>￥{{payMoney}}</p>
					</div>
					<div v-if="manualType==1">
						<h6 style="width: 100px;">手动优惠金额：</h6>
						<p>￥{{manualOffer}}</p>
					</div>
					<div v-else-if="manualType==2">
						<h6>手动折扣：</h6>
						<p>{{manualDiscount}}折</p>
					</div>
					<div v-if="manualType==1">
						<h6 style="width: 100px;">优惠后金额：</h6>
						<p>￥{{((payMoney*100 - manualOffer*100)/100).toFixed(2)}}</p>
					</div>
					<div v-else-if="manualType==2">
						<h6 style="width: 100px;">折扣后金额：</h6>
						<p>￥{{((payMoney*manualDiscount)/100).toFixed(2)}}</p>
					</div>
					<div v-if="selectCurrency.payType == 5">
						<h6>{{selectCurrency.name}}：</h6>
						<p>会员每【{{shopSetInfo.pointCredit}}】积分，抵现【1】元</p>
					</div>
					<div v-else-if="selectCurrency.payType == 6">
						<h6>{{selectCurrency.name}}：</h6>
						<p>汇率：{{selectCurrency.exchange}}</p>
					</div>
					<div class="member_verify" v-if="selectCurrency.payType != 5">
						<h6>实收：</h6>
						<p>
							<el-input type="number" v-model="otherPayMoney" placeholder="实收金额" @focus="focus($event)"
              @input="otherPayMoneyFn" clearable :disabled="selectCurrency.payType == 4"></el-input>
						</p>
					</div>
					<div v-if="selectCurrency.payType == 5">
						<h6>所需积分：</h6>
						<p>{{selectCurrency.pointCredit}}分</p>
					</div>
					<div v-if="selectCurrency.payType == 5">
						<h6>剩余积分：</h6>
						<p>{{memberInfo.surplusIntegral - selectCurrency.pointCredit}}分</p>
					</div>
					<div v-if="selectCurrency.payType != 5">
						<h6>实收金额：</h6>
						<p>￥{{selectCurrency.actualAmount || 0}}</p>
					</div>
					<div v-if="selectCurrency.payType != 5">
						<h6>找零：</h6>
						<p>￥{{selectCurrency.change || 0}}</p>
					</div>
				</div>
				<div class="member_btn">
					<el-button @click="otherPayWindow=false">取消</el-button>
					<!--<el-button>确认</el-button>-->
					<el-button @click="goPay(1, selectCurrency.payType)">确认</el-button>
				</div>
			</div>
		</div>

		<div class="addMember" v-if="addMemberShow" @click="addMemberShow=false">
			<div class="addMember_wrap" @click.stop>
				<h2>快捷新增会员</h2>
				<div class="addMember_content">
					<div class="addMember_list">
						<h6>会员名称：</h6>
						<p>
							<el-input v-model="addMemberInfo.name" placeholder="会员名称" @focus="focus($event)" clearable></el-input>
						</p>
					</div>
					<div class="addMember_list">
						<h6>联系方式：</h6>
						<p>
							<el-input type="number" v-model="addMemberInfo.phone" placeholder="联系方式" @focus="focus($event)" clearable></el-input>
						</p>
					</div>
					<div class="addMember_list">
						<h6>会员卡类型：</h6>
						<p>
							<el-select v-model="addMemberInfo.categoryId" placeholder="请选择">
								<el-option v-for="(i, index) in categoryList" :key="index" :label="i.categoryName" :value="i.levelId"></el-option>
							</el-select>
						</p>
					</div>
				</div>
				<div class="addMember_btn" @click="saveMember">确认新增</div>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs';
	import md5 from 'js-md5'
	import { interfaceFn } from '@/assets/util.js';
	export default{
		data () {
			return {
				msg: '',
				name: 'Pay',
				shopInfo: {},
				shopName: '',
				tabName: '',//当前的桌台名称
				tabId: 0,//当前的桌台id
				shopId: 0,//当前的门店id
				allCartList: [],//购物车列表信息
				newCartList: [],//新加的菜的信息
				oldCartList: [],//旧加的菜的信息
				eatNum: 1,//就餐人数
				memberCode: '',//服务员编号
				allMoney: 0,//购物车总价
				teaFee: 0,//服务费
				remarks: '',//整单备注
				promptMsg: true,//是否是本店员工的提示信息
				tasteFlag: false,//口味弹窗
				tasteName: '',//自定义口味名称
				tasteList: [],//系统口味列表信息
				currFoodId: '',//当前选口味的菜品id
				currFoodIndex: '',//当前选口味的菜品index
				currFood: {},//当前选口味的菜品
				isFirstNum: 1,//是否是首次下单：0否，1是
				cashPledge: 0,//押金
				isScan: false,//判断是否是扫码点餐
				model: 0,
				imguri: interfaceFn(1),

				optFood: {},
				optFood2: {},
				optShow: false,
				optType: 1,// 1状态，2价格，3数量，4折扣
				statusList: [{id: 0,name: '新品'}, {id: 1,name: '不厨打'}, {id: 2,name: '厨打'}, {id: 3,name: '等叫'}
					, {id: 4,name: '叫起'}, {id: 5,name: '催菜'}, {id: 6,name: '划菜'}, {id: 7,name: '退菜'}],


				// 折扣方案
				discountPlan: [],
				discountShow: false,

				// 支付
				memberInfo: {},// 添加的会员信息
				payShow: false,
				payMoney: 0,//实付金额
				discountMoney: 0,//优惠金额
				discountInfo: [],//优惠后的列表

				manualType: '0',// 0:无优惠，1：手动优惠，2：手动折扣
				manualDiscount: '',// 手动折扣
				manualOffer: '',// 手动优惠
				shopSetInfo: {},//门店设置信息
				password: '',
				verifyCode: 'v-v*',// 獲取的驗證碼
				code: '',
				time: 0,

				selectPromotion: 0,
				userInfo: {userThronesEntity: {}},
				openid: '',

				otherPay: false,
				otherOffPay: false,
				otherPayWindow: false,
				otherPayMoney: 0,
				currencyList: [],
				selectCurrency: {},
				curClickInfo: {},

				categoryList: [],
				addMemberInfo: {name: '',categoryId: '',phone: ''},
				addMemberShow: false,
				modelPay: '',
				numShow: false,
			}
		},

		created () {
			this.init();
		},
		filters: {
			// 过滤只保留小数点后三位
			capitalize: function (value) {
				if (!value) return 0
				value = Math.floor(Number(value) * 1000) / 1000
				return value
			}
		},

		methods: {
			init () {
				var arr = [];
        this.$store.state.memberInfo = {};
				this.isScan = this.$store.state.isScan;
				this.shopInfo = this.$store.state.shopInfo;
				this.openid = this.$store.state.scanInfo.openid;
				let userInfo = window.localStorage.getItem('userInfo');
				this.userInfo = userInfo ? JSON.parse(userInfo) : {userThronesEntity: {}};
//				this.memberInfo = this.$store.state.memberInfo;
				/*var againClickInfo = JSON.parse(window.localStorage.getItem('againClickInfo'));
				if (againClickInfo) {//判断是否是修改桌台的操作
					var curClickInfo = againClickInfo;//修改了桌台
				} else {
					var curClickInfo = JSON.parse(window.localStorage.getItem('curClickInfo'));//获取当前点击的桌台信息
					if (!curClickInfo.employeeId) {
						curClickInfo.employeeId = JSON.parse(window.localStorage.getItem('logindata')).memberCode;
					}
				}*/
				this.model = window.localStorage.getItem('model');
				this.modelPay = window.localStorage.getItem('modelPay');
				this.shopName = window.localStorage.getItem('shopName');
				this.cashPledge = window.localStorage.getItem('cashPledge');
				var curClickInfo = JSON.parse(window.localStorage.getItem('curClickInfo'));//获取当前点击的桌台信息
				this.curClickInfo = curClickInfo;
				/*if (!curClickInfo.employeeId) {// 使用第一次点餐员编号
					curClickInfo.employeeId = JSON.parse(window.localStorage.getItem('logindata')).memberCode;
				}
				this.memberCode = curClickInfo.employeeId;*/
				if (!this.isScan) {// 使用当前登录的点餐员编号
					this.memberCode = JSON.parse(window.localStorage.getItem('logindata')).memberCode;
				}
				this.tabName = curClickInfo.title;

				var cartInfo = window.localStorage.getItem('cartInfo');//获取当前点击的桌台的点餐信息
				if (cartInfo) {
					cartInfo = JSON.parse(cartInfo);
					this.eatNum = cartInfo.orderInfo.mealsNumber || 1;
					this.remarks = cartInfo.orderInfo.remarks;
				}
				if (this.isScan) {
					this.tabId = this.$store.state.scanInfo.tab;
					this.shopId = this.$store.state.scanInfo.sho;
				} else {
					this.tabId = curClickInfo.id;
					this.shopId = curClickInfo.shopId;
				}

				var newCartList = localStorage.getItem('newCartList') ? JSON.parse(localStorage.getItem('newCartList')) : [];
				var oldCartList = localStorage.getItem('oldCartList') ? JSON.parse(localStorage.getItem('oldCartList')) : [];
				this.newCartList = newCartList;
				this.oldCartList = oldCartList;

				let has = newCartList.filter(f => f.otherStatus == 2);
				if (oldCartList.length == 0 && has.length == 0) {
					this.isFirstNum = 1;//0否，1是，是否是首次下单
				} else {
					this.isFirstNum = 0;
				}

				if (newCartList && oldCartList) {
					this.allCartList = arr.concat(oldCartList, newCartList);
				} else if (newCartList) {
					this.allCartList = newCartList;
				} else if (oldCartList) {
					this.allCartList = oldCartList;
				}

				var allMoney = window.localStorage.getItem('allFoodsMoney');
				this.allMoney = allMoney;

				var noteInfo = window.localStorage.getItem('noteInfo');
				if (noteInfo) {
					window.localStorage.removeItem('noteInfo');
					noteInfo = JSON.parse(noteInfo);
					this.eatNum = noteInfo.eatNum;
					this.remarks = noteInfo.remarks;
				}

				// 计算优惠价格--下单计算金额
				/*if (newCartList.length > 0) {
					let newArr = [];
					newCartList.filter(f => {
						newArr.push({
							"foodId": f.foodId,
				            "foodName": f.foodName,
				            "foodImage": f.foodImage,
				            "price": f.price,
				            "salesPrice": f.price,
				            "qty": f.qty,
				            "unitPrice": f.price,
				            "allMoney": (f.allMoney * 100 * f.qty) / 100,
				            "isAdd": 0,
				            "unit": f.unit,
				            "remark": (f.remark.length > 0 ? f.remark : ''),
				            "createTime": f.createTime,
				            "mealItemsDtos": f.mealItemsDtos
						});
					});
					this.$http.post('/selfServiceCash/downOrder', {
						"orderInfo": {
							"shopId": window.localStorage.getItem('shopId'),
							"memberId": this.memberInfo.memberInfoId,
							"numberNumber": this.eatNum,
							"remarks": this.remarks
						},
						"orderItems": newArr
					}).then((res) => {
						if (res.data.returnCode == 'ok') {
							let data = res.data.data;
							console.log('计算优惠：',data);

						} else {
							this.msgFn(1000, res.data.message, 'warning');
						}
					}).catch(() => {
						this.msgFn(500, '服务器错误，请稍后重试', 'error');
					})
				}*/
			},

			//获取焦点时，选中全部的内容
			focus (event) {
		    	event.currentTarget.select();
		    },

		    eatNumFn(){
		        this.numShow = true;
		    },

		    // 扫码点餐选择人数
		    selectNum() {
		        this.numShow = false;
		        window.localStorage.setItem('noteInfo', JSON.stringify({
		          "eatNum": this.eatNum
		        }));
		    },

		    /* 选择人数滚动事件 */
		    handlerScroll(e) {
		        let scroll = parseInt((e.srcElement.scrollTop) / 22);
		        if (scroll <= 0) {
		          this.eatNum = 1;
		        } else {
		          this.eatNum = scroll;
		        }
		    },

			//返回按钮
			goBack () {
				window.localStorage.removeItem('goSelectTab');
				window.localStorage.setItem('payBack', true);
				window.localStorage.setItem('noteInfo', JSON.stringify({
					eatNum: this.eatNum,
					remarks: this.remarks,
				}));
				this.$router.push({path: "/room", query:{judge: 1}});
				// this.$router.push({path: "/room"});
			},

			// 查看订单
			showInfo () {
				if (!this.openid) return;
				this.$router.push({path: '/ticket'});
			},

			//选择桌台操作
			goSelectTab () {
				window.localStorage.setItem('goSelectTab', 1);
				window.localStorage.setItem('noteInfo', JSON.stringify({
					eatNum: this.eatNum,
					remarks: this.remarks,
				}));
				this.$router.push({path: "/home"});
			},

			// 获取会员信息
			getMember () {
				this.$prompt('请输入会员卡号/号码', '会员信息', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputType: 'number',
					inputPattern: /\S/,
					inputErrorMessage: '搜索内容不能为空'
				}).then(({ value }) => {
					this.getMemberInfo(value);
				}).catch(() => {});
			},

			// 获取会员
			getMemberInfo (value) {
        this.discountMoney = 0;
        this.$store.state.memberInfo = {};
        this.memberInfo = {};

				this.$http.post(interfaceFn()+'/member/getMemberInfo',
        qs.stringify({
          merchantId: window.localStorage.getItem('merchantId'),
          phoneOrNo: value
        }), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }).then((res) => {
					if (res.data.returnCode == 'ok') {
						let data = res.data.data;
						this.memberInfo = data;
						this.$store.state.memberInfo = data;
						this.getMDiscount();
						this.getSSetFn();
					} else {
						this.msgFn(1000, res.data.message, 'warning');
					}
        }).catch((err) => {
          this.msgFn(500, '服务器错误，请稍后重试', 'error');
        });
			},

			// 获取会员优惠
			getMDiscount () {
				this.$http.post(interfaceFn()+'/orderMessage/reloadMemberOrder',
				qs.stringify({
			  		shopId: window.localStorage.getItem('shopId'),
			  		tableId: JSON.parse(window.localStorage.getItem('curClickInfo')).id,
			  		memberId: this.memberInfo.memberId,
			  		orderItems: JSON.stringify(this.infoFn())
				}), {
			    	headers: {
			    		"Content-Type": "application/x-www-form-urlencoded"
			    	}
				}).then((res) => {
					if (res.data.returnCode == 'ok') {
						let result = res.data.result;
						this.discountInfo = result.orderItems;
						let payMoney = result.orderItems.map(i => Number(i.allMoney)).reduce(((a, b) => a + b), 0).toFixed(2);
						this.discountMoney = ((this.allMoney * 100 - payMoney * 100) / 100).toFixed(2);
						this.teaFee = Math.floor(this.curClickInfo.teaFee * payMoney) / 100;
						this.payMoney = ((payMoney * 100 + this.teaFee * 100) / 100).toFixed(2);
					} else {
						this.msgFn(1000, res.data.message, 'error');
					}
				})
			},

			// 删除会员信息
			clearInfoFn () {
				this.memberInfo = {};
				this.$store.state.memberInfo = {};
				this.teaFee = Math.floor(this.curClickInfo.teaFee * this.allMoney) / 100;
				this.payMoney = ((this.allMoney * 100 + this.teaFee * 100) / 100).toFixed(2);
				this.discountMoney = 0;
			},

			// 新增会员
			addMember () {
				this.$http.post(interfaceFn()+'/member/findMemberLevelByEnterprise',
				qs.stringify({
			  		merchantId: window.localStorage.getItem('merchantId')
				}), {
		    		headers: {
		    			"Content-Type": "application/x-www-form-urlencoded"
		    		}
				}).then((res) => {
					if (res.data.code == 0) {
						let msg = res.data.msg;
						this.categoryList = msg;
						this.addMemberShow = true;
						this.addMemberInfo = {name: '',categoryId: (msg.length > 0 ? msg[0].levelId : ''),phone: ''};
					}
				}).catch(() => {})
			},
			// 新增会员保存
			saveMember () {
				if (!this.addMemberInfo.name) {
					this.msgFn(1500, '请输入会员名称', 'warning');
					return;
				}
				if (!this.addMemberInfo.phone) {
					this.msgFn(1500, '请输入联系方式', 'warning');
					return;
				}
				if (!this.addMemberInfo.categoryId) {
					this.msgFn(1500, '请选择会员卡等级', 'warning');
					return;
				}

				let data = {
					shopId: window.localStorage.getItem('shopId'),
					merchantId: window.localStorage.getItem('merchantId'),
					cardNo: this.addMemberInfo.phone,
					memberName: this.addMemberInfo.name,
					memberPhone: this.addMemberInfo.phone,
					levelId: this.addMemberInfo.categoryId,
					sex: 0,
					isPermanented: 0
				}
				this.$http.post(interfaceFn()+'/member/addMemberInfo', data).then((res) => {
					this.addMemberShow = false;
					if (res.data.code == 0) {
						this.getMemberInfo(res.data.msg.memberPhone);
					} else if (res.data.code == -2) {
						let info = res.data.data;
						const h = this.$createElement;
						this.$msgbox({
							title: '会员已存在',
							message: h('div', null, [
								h('p', null, '卡号：' + info.cardNo),
								h('p', null, '号码：' + info.memberPhone),
								h('p', null, '名称：' + info.memberName),
								h('p', null, '性别：' + (info.sex == 1 ? '女' : '男')),
								h('p', null, '会员等级：' + info.categoryName),
								h('p', null, '储值余额：￥' + info.balanceAmount),
								h('p', null, '拥有积分：' + info.surplusIntegral),
								h('p', null, '所在门店：' + info.shopName)
							]),
							showCancelButton: true,
							confirmButtonText: '使用',
							cancelButtonText: '放弃',
						}).then(action => {
							this.getMemberInfo(info.memberPhone);
						}).catch((err) => {});
					} else {
						this.msgFn(1500, res.data.msg, 'warning');
					}
				}).catch((err) => {
					this.addMemberShow = false;
					this.msgFn(1500, '服务器错误！', 'error');
				})
			},

			// 获取门店设置
			getSSetFn () {
				this.$http.post(interfaceFn()+'/member/getMemberSetting',
				qs.stringify({
			  		merchantId: window.localStorage.getItem('merchantId')
				}), {
		    		headers: {
		    			"Content-Type": "application/x-www-form-urlencoded"
		    		}
				}).then((res) => {
					if (res.data.code == 0) {
						let msg = res.data.msg;
						this.shopSetInfo = msg;
						if (msg.isSendVerificationCode == 1) {//会员消费是否发送验证码（0：否，1：是）
							this.getCodeFn();
						}
					}
				})
			},

			// 获取验证码
			getCodeFn () {
				this.$http.post(interfaceFn()+'/member/sendVerificationCodeSignature',
        qs.stringify({
          merchantId: window.localStorage.getItem('merchantId'),
          phone: this.memberInfo.memberPhone,
        }), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }).then((res) => {
          if (res.data.message == 'ok') {
            this.msgFn(1500, '发送成功', 'success');
            this.verifyCode = res.data.code;
            this.time = 60;
            this.countDown();
          } else {
            this.msgFn(1500, res.data.message, 'warning');
          }
        }).catch((err) => {
          this.msgFn(1500, '服务器错误', 'error');
        });
			},

			// 验证码倒计时
		    countDown: function () {
          if (this.time > 0) {
            this.time--;
            setTimeout(this.countDown, 1000);
          }
		    },

			//员工编号失去焦点事件
			changeMCode () {
				this.$http.post(interfaceFn()+'/isWaiter',
        qs.stringify({
          shopId: window.localStorage.getItem('shopId'),
          code: this.memberCode
        }), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }).then((res) => {
          if (res.data.returnCode == 'error') {
            this.msgFn(500, '该员工编号不存在', 'error');
            this.promptMsg = false;
          } else {
            this.promptMsg = true;
          }
        }).catch((err) => {});
			},

			// 修改菜品状态
			getFoodFn (i, n, index) {
				if (this.$store.state.isScan) {
					this.optType = 1;
				}
				i.isNew = n;
				i.index = index;
				i.canteenStatus += '';
				this.optFood2 = i;
				this.optFood = JSON.parse(JSON.stringify(i));
				this.optShow = true;
			},
			// 修改菜品状态
			optConfirm () {
				let obj = '';
				if (this.optFood.isNew == 1) {
					obj = 'newCartList';
				} else {
					obj = 'oldCartList';
				}
				this[obj][this.optFood.index].canteenStatus = this.optFood.canteenStatus;
        if (this.optFood.canteenStatus == 5) {
          this[obj][this.optFood.index].urgeNum += 1;
        }
				this.optShow = false;
			},

			// 2修改价格-3数量-4折扣-5赠送-6退菜
			editFn (n) {
				this.optType = n;
				let purview = this.userInfo.userThronesEntity;// 权限
				let note = '', title = '', pattern = /\S/, val = '', placeholder = '';
				if (n == 2) {
					if (purview.iseditprice == 0) {
						this.msgFn(1500, '暂无价格权限', 'warning');
						return;
					}
					note = '价格';
					pattern = /^(?!0(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,2})?$/;
					val = this.optFood.price;
				} else if (n == 3) {
					title = '数量';
					if (this.optFood.isweigh == 1) {
						pattern = /^(?!0(?:\.0+)?$)(?:[1-9]\d*|0)(?:\.\d{1,3})?$/;
						note = '限3位小数，数量';
					} else {
						pattern = /^[1-9]\d*$/;
						note = '必须为正整数，数量';
					}
					val = this.optFood.qty;
				} else if (n == 4) {
					if (purview.isdiscount == 0) {
						this.msgFn(1500, '暂无折扣权限', 'warning');
						return;
					}
					note = '折扣';
					val = this.optFood.discount;
					placeholder = '数字90即：9折，100或0不打折';
				} else if (n == 5) {
					if (purview.isOpenTable == 0) {
						this.msgFn(1500, '暂无赠送权限', 'warning');
						return;
					}
					note = '赠送';
					title = '赠送数量';
					val = this.optFood.qty;
				} else if (n == 6) {
					if (purview.backfood == 0) {
						this.msgFn(1500, '暂无退菜权限', 'warning');
						return;
					}
					note = '退菜';
					title = '退菜数量';
					val = this.optFood.qty;
				}

				this.optShow = false;
				let promptMsg = {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputType: 'number',
					inputPattern: pattern,
					inputValue: val,
					inputErrorMessage: note + '格式不正确/内容不能为空'
				}
				if (n == 4) promptMsg.inputPlaceholder = placeholder;
				this.$prompt('请输入' + (title || note), (n == 3 ? title : note), promptMsg).then(({ value }) => {
					let obj = this.optFood.isNew == 1 ? 'newCartList' : 'oldCartList';
					let index = this.optFood.index;
					if (n == 2) {// 价格
						this[obj][index].price = Number(value);
						//this[obj][index].originalPrice = Number(value);
						this[obj][index].unitPrice = Number(value);
						this[obj][index].discount = 0;
					} else if (n == 3) {// 数量
            if(Number(value) >= this[obj][index].startOrderQty || this[obj][index].startOrderQty == 1){//大于等于起点数量
              this[obj][index].qty = Number(value);
              this[obj][index].givefoodnumber = 0;
              this[obj][index].discount = 0;
            }else{
              let _this = this;
              _this.msgFn(1500, '不能小于起点数量', 'warning');
              setTimeout(function(){
                _this.editFn(3);
              },1500)
            }

					} else if (n == 4) {// 折扣
						this[obj][index].discount = Number(value);
						let price = 0;
						if (!this[obj][index].originalPrice) {
							price = this[obj][index].price;
							this[obj][index].originalPrice = price;
						} else {
							price = this[obj][index].originalPrice;
						}
						let newPrice = (price * 100 * this[obj][index].qty * Number(value)) / 10000;
						this[obj][index].allMoney = newPrice;
						this[obj][index].price = newPrice;
						this[obj][index].unitPrice = newPrice;
					} else if (n == 5) {// 赠送
						if (value > this.optFood.qty) {
							this.editFn(5);
							this.msgFn(1500, '赠送数量不能大于拥有的数量', 'warning');
						} else {
							this.$prompt('请输入理由', '赠菜理由', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								inputPattern: /\S/,
								inputValue: '无理由',
								inputErrorMessage: '理由不能为空'
							}).then((reason) => {
								if (!this[obj][index].remark) {
									this[obj][index].remark = [{name: '赠菜:' + reason.value,price: 0}];
								} else {
									this[obj][index].remark.push({name: '赠菜:' + reason.value,price: 0});
								}
								this[obj][index].qty = Number(((this[obj][index].qty * 100 - value * 100 ) / 100).toFixed(2));
								this[obj][index].givefoodnumber = Number((((this[obj][index].givefoodnumber || 0) * 100 + value * 100 ) / 100).toFixed(2));
								this[obj][index].giveQty = this[obj][index].givefoodnumber;

							}).catch(() => {});
						}
					} else if (n == 6) {
						if (value > this.optFood.qty) {
							this.editFn(6);
							this.msgFn(1500, '退菜数量不能大于已点的数量', 'warning');
						} else {
							this.$prompt('请输入理由', '退菜理由', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								inputPattern: /\S/,
								inputValue: '无理由',
								inputErrorMessage: '理由不能为空'
							}).then((reason) => {
								if (!this[obj][index].remark) {
									this[obj][index].remark = [{name: '退菜:' + reason.value,price: 0}];
								} else {
									this[obj][index].remark.push({name: '退菜:' + reason.value,price: 0});
								}

								this[obj][index].qty = Number(((this[obj][index].qty * 100 - value * 100 ) / 100).toFixed(2));
								this[obj][index].returnfoodnumber = Number((((this[obj][index].returnfoodnumber || 0) * 100 + value * 100 ) / 100).toFixed(2));
								this[obj][index].returnQty = this[obj][index].returnfoodnumber;
							}).catch(() => {});
						}
					}

					this[obj][index].allMoney = this[obj][index].price;
					this.getAllPrice();// 计算金额
				}).catch(() => {});
			},

			// 手动折扣-优惠点击
			typeChange (val) {
				let purview = this.userInfo.userThronesEntity;
				if (val == 1 && purview.isprivilege == 0) {
					this.msgFn(1500, '暂无优惠权限', 'warning');
					this.manualType = '0';
				} else if (val == 2 && purview.isdiscount == 0) {
					this.msgFn(1500, '暂无折扣权限', 'warning');
					this.manualType = '0';
				}
				this.manualOffer = '';
				this.manualDiscount = '';
			},

			// 合计金额
			getAllPrice () {
				window.localStorage.setItem('newCartList', JSON.stringify(this.newCartList));//新加的菜
				window.localStorage.setItem('oldCartList', JSON.stringify(this.oldCartList));//新加的菜
				var cartInfo = window.localStorage.getItem('cartInfo');//获取当前点击的桌台的点餐信息
				if (cartInfo) {
					cartInfo = JSON.parse(cartInfo);
					cartInfo.orderItem = this.oldCartList;
					window.localStorage.setItem('cartInfo', JSON.stringify(cartInfo));
				}
				let cartList = this.newCartList.concat(this.oldCartList);
				var allMoney = (cartList.map(i => Number(i.allMoney * i.qty)).reduce(((a, b) => a + b), 0)).toFixed(2);//购物车的总价
				this.allMoney = ((this.teaFee * 10000 + allMoney * 10000)/10000).toFixed(2);//加上服务费的总价
				window.localStorage.setItem('allFoodsMoney', allMoney);//设置当前购物车的所有金额
				window.localStorage.setItem('allPrices', this.allMoney);//设置加上服务费的金额
				this.init();
			},

			// 获取折扣方案
			discountFn () {
				this.$http.get(interfaceFn()+'/merchantFood/getDiscountPlan?merchantId=' + window.localStorage.getItem('merchantId')
				+ '&shopId=' + window.localStorage.getItem('shopId')).then((res) => {
					if (res.data.returnCode == 'ok') {
						let list = res.data.result;
						if (list.length == 0) {
							this.msgFn(1500, '不存在折扣方案', 'warning');
							return;
						}
						this.optShow = false;
						this.discountShow = true;
						this.discountPlan = [
							{
								name: '赠送方案',
								type: 0,
								list: list.filter(f => f.type == 0)
							},{
								name: '折扣方案',
								type: 1,
								list: list.filter(f => f.type == 1)
							},{
								name: '上量折扣',
								type: 2,
								list: list.filter(f => f.type == 2)
							}
						];
					} else {
						this.msgFn(1500, res.data.message, 'warning');
					}
				}).catch((err) => {
					this.msgFn(1500, '服务器错误，请稍后重试', 'error');
				});
			},

			// 折扣方案确认
			confirmDiscount () {
				let info = {};
				this.discountPlan.filter(f => {
					f.list.filter(k => {
						if (k.id == this.selectPromotion) info = k;
					});
				});
				if (!info.id) {
					this.msgFn(1000, '请选择一个折扣方案', 'warning');
					return;
				}

				let index = this.optFood.index;
				let newInfo = JSON.parse(JSON.stringify(this.optFood));
				delete newInfo.index;
				delete newInfo.isNew;
				if (info.type == 0) {
					newInfo.givefoodnumber = info.value2;
					if (this['newCartList'][index].qty < info.value1) {
						newInfo.qty = info.value1;
					}
					this['newCartList'][index] = newInfo;
				} else if (info.type == 1) {
					if (this['newCartList'][index].qty < info.value1) {
						this['newCartList'][index].qty = info.value1 - 1;
					}
					newInfo.discount = info.value2;
					let price = (newInfo.originalPrice * 100 * info.value2) / 10000;
					newInfo.allMoney = price;
					newInfo.price = price;
					newInfo.unitPrice = price;
					this['newCartList'].splice(index + 1, 0, newInfo);
				} else if (info.type == 2) {
					if (this['newCartList'][index].qty < info.value1) {
						newInfo.qty = info.value1;
					}
					newInfo.discount = info.value2;
					let price = (newInfo.originalPrice * 100 * info.value2) / 10000;
					newInfo.allMoney = price;
					newInfo.price = price;
					newInfo.unitPrice = price;
					this['newCartList'][index] = newInfo;
				}
				this.getAllPrice();// 计算金额
				this.discountShow = false;
			},

			//显示口味弹窗
			getTaste (food, index) {
				this.tasteFlag = true;
				this.currFoodId = food.foodId;
				this.currFoodIndex = index;
				this.currFood = food;
				this.$http.get(interfaceFn()+'/merchantFood/getMerchantTaste?merchantId='
        + localStorage.getItem('merchantId')).then((res) => {
          if (res.data.returnCode == 'ok') {
            var info = res.data.tasteList;
            for (var i = 0; i < info.length; i++) {
              info[i].isSelected = false;

              //循环购物车的菜品，判断当前点击的菜品的口味是否是系统的口味
              for (var k = 0; k < food.remark.length; k++) {
                var remarkList = food.remark[k];
                if (remarkList.id == info[i].id) {// 增加id进行判断
                  info[i].isSelected = true;
                }
              }
              /* for (var j = 0; j < this.newCartList.length; j++) {
                if (food.foodId == this.newCartList[j].foodId) {
                  if (this.newCartList[j].remark) {
                    for (var k = 0; k < this.newCartList[j].remark.length; k++) {
                      var remarkList = this.newCartList[j].remark[k];
                      if (remarkList.id == info[i].id) {// 增加id进行判断
                      //if (remarkList.price == info[i].costFee && remarkList.name == info[i].title && remarkList.id == info[i].id) {
                        info[i].isSelected = true;
                      }
                    }
                  }
                }
              } */
            }
            let customize = food.remark.filter(f => f.id == 0);
            if (customize.length > 0) {
              customize.filter(f => {
                info.push(JSON.parse(JSON.stringify({
                  costFee: f.price,
                  id: 0,
                  isSelected: true,
                  merchantId: window.localStorage.getItem('merchantId'),
                  title: f.name
                })))
              })
            }
            this.tasteList = info;

          } else {
            this.msgFn (2000, res.data.message, 'error');
          }
        }).catch((err) => {});
			},

			//选中口味改变样式
			selectBtn (info) {
				for (var i of this.tasteList) {
					//i.isSelected = (i.id == info.id) && !i.isSelected;//可选中取消
					if (i.id == info.id) {
						i.isSelected = !i.isSelected
					}
				}
			},

			// 自定义口味
			customizeTaste () {
				if (!this.tasteName) {
					this.msgFn(2000, '请输入口味名称', 'warning');
					return;
				}
				this.tasteList.push({
					costFee: 0,
					id: 0,
					isSelected: true,
					merchantId: window.localStorage.getItem('merchantId'),
					title: this.tasteName
				});
				this.tasteName = '';
			},
			//口味选中确定按钮
			determineTaste () {
				var selectSystemTaste = [];//选中的系统口味
				this.tasteList.filter(f => {
					if (f.isSelected == true) {
						selectSystemTaste.push(f);
					}
				});

				var oldPrice = 0;
				if (this.currFood.remark) {
					oldPrice = this.currFood.remark.map(t => t.price).reduce((a, b) => a + b, 0);
				}

				var newTaste = new Array();
				/*var tasteNames = this.tasteList.map(t => t.title);
				for (var t of (this.currFood.remark || [])) {
					if (tasteNames.indexOf(t.name) == -1) {
						newTaste.push(t);
					}
				}*/

				// 获取选规格的口味
				for (var t of (this.currFood.remark || [])) {
					if (!t.system) {
						newTaste.push(t);
					}
				}
				// 选中的口味
				selectSystemTaste.filter(f => {
					newTaste.push({
						name: f.title,
						price: f.costFee,
						id: f.id,
						system: true
					});
				});

				var remarksPrice = newTaste.map(i => i.price).reduce(((a, b) => a + b), 0);//当前设置的系统口味的价格
				this.currFood.remark = newTaste;//设置当前点击的系统口味
				this.currFood.allMoney = ((this.currFood.allMoney * 100  + remarksPrice * 100 - oldPrice * 100)/100).toFixed(2);//加上系统口味的价格

				if (this.oldCartList) {//判断是否加菜
					this.allCartList = this.newCartList.concat(this.oldCartList);
				} else {
					this.allCartList = this.newCartList;
				}

				var allMoney = (this.allCartList.map(i => Number(i.allMoney * i.qty)).reduce(((a, b) => a + b), 0)).toFixed(2);//购物车的总价
				this.allMoney = ((this.teaFee * 10000 + allMoney * 10000)/10000).toFixed(2);//加上服务费的总价;
				window.localStorage.setItem('newCartList', JSON.stringify(this.newCartList));//新加的菜
				window.localStorage.setItem('allFoodsMoney', allMoney);//设置当前购物车的所有金额
				window.localStorage.setItem('allPrices', this.allMoney);//设置加上服务费的金额
				this.tasteFlag = false;
			},

			/*
			 * @param numId 服务员点菜提交订单按钮
			 * 1：立即支付
			 * 2：提交订单
			 * 3：model:2-1扫码点餐模式立即支付(先下单在进行支付操作)
			 * 4：立即支付弹出输入会员信息
			 *
			 * @param payType
			 * 0：微信支付，1：会员支付，2：支付宝，3：现金，4：银联，5：积分抵现，6：其他支付
			 * */
			goPay (numId, payType) {
				if (this.selectCurrency.change < 0) {
					this.msgFn(2000, '支付金额小于应收金额', 'warning');
					return;
				}
				// 权限
				let purview = this.userInfo.userThronesEntity;
				if (purview.isDownOrder == 0) {
					this.msgFn(2000, '暂无下单权限', 'warning');
					return;
				}
				if ((numId == 1 || numId == 4) && purview.isSettleAccounts == 0) {
					this.msgFn(2000, '暂无结账权限', 'warning');
					return;
				}
				if (numId == 1 && payType) {
					if (purview.privilege < (this.manualOffer || 0) && this.manualType == 1) {
						this.msgFn(2000, '优惠超过上限', 'warning');
						return;
					}
					if (purview.discount > (this.manualDiscount || 100) && this.manualType == 2) {
						this.msgFn(2000, '折扣超过下限', 'warning');
						return;
					}
				}

				// 会员支付验证
				if (payType == 1) {
					// 门店验证码验证
					if (this.shopSetInfo.isSendVerificationCode == 1) {
						if (!this.code) {
							this.msgFn(2000, '验证码不能为空', 'warning');
					        return;
						}
						if (this.code != this.verifyCode) {
							this.msgFn(2000, '验证码不正确', 'warning');
					        return;
						}
					} else if (this.shopSetInfo.isSendVerificationCode == 0 && this.memberInfo.password) {
						if (!this.code && !this.password) {
							this.msgFn(2000, '请至少选择一种验证方式', 'warning');
					        return;
						}
						if (this.password) {
							if (md5(this.password) != this.memberInfo.password) {
								this.msgFn(2000, '密码不正确', 'warning');
						        return;
							}
						} else if (this.code) {
							if (this.code != this.verifyCode) {
								this.msgFn(2000, '验证码不正确', 'warning');
						        return;
							}
						}
					}
				}

				var curClickInfo = JSON.parse(window.localStorage.getItem("curClickInfo"));
				if (numId == 1 && curClickInfo.lowerCost > this.allMoney) {
					// 最低消费提示
					this.$confirm('该桌台最低消费为【￥' + curClickInfo.lowerCost + '】，是否继续结算？', '最低消费', {
						distinguishCancelAndClose: true,
						confirmButtonText: '确定',
						cancelButtonText: '加菜',
						type: 'warning'
					}).then(() => {
						this.reqFn(numId, payType);
					}).catch((action) => {
						if (action === 'cancel') this.goBack();
					});
					return;
				} else if (numId == 4) {
					this.payShow = true;
					this.teaFee = Math.floor(curClickInfo.teaFee * this.allMoney) / 100;
					this.payMoney = ((this.teaFee * 100 + this.allMoney * 100) / 100).toFixed(2);
					/* this.discountMoney = 0;
					this.$store.state.memberInfo = {};
					this.memberInfo = {}; */
					return;
				}
				this.reqFn(numId, payType);
			},

			// 处理后的数据
			infoFn (time) {
				time ? '' : time = this.showTime();//当前的时间
				var listCopy = new Array();
				listCopy = JSON.parse(JSON.stringify(this.allCartList));
				for (var i = 0; i < listCopy.length; i++) {
					if (!listCopy[i].createTime) {
            listCopy[i].createTime = listCopy[i].time || time;
						listCopy[i].isAdd = listCopy[i].time ? 1 : 0;
						listCopy[i].canteenStatus = listCopy[i].canteenStatus || 2;
						listCopy[i].status = listCopy[i].status || 1;
						delete listCopy[i].time;
					} else {
						listCopy[i].isAdd = 1;
					}

					listCopy[i].unitPrice = listCopy[i].price;
					listCopy[i].price = listCopy[i].allMoney;
					listCopy[i].originalPrice = listCopy[i].originalPrice || listCopy[i].price;
					listCopy[i].setMealItems = listCopy[i].setMealItems || [];

					if (listCopy[i].remark && listCopy[i].remark.length>0) {
						var remarks = [];
						for (var j = 0; j < listCopy[i].remark.length; j++) {
							var list = listCopy[i].remark[j];
							remarks.push('"' + list.name + '":' + list.price);
						}
						listCopy[i].remark = "{" + remarks.join(',') + "}";
					} else {
						// listCopy[i].remark = this.isScan && listCopy[i].isweigh == 1 ? '未称重' : '';
						listCopy[i].remark = '';
					}
					// 结账加上赠送的数量
					if (listCopy[i].giveQty) {
						listCopy[i].qty += Number(listCopy[i].giveQty);
						delete listCopy[i].giveQty;
					} else if (listCopy[i].givefoodnumber) {
						listCopy[i].qty += Number(listCopy[i].givefoodnumber);
					}
					// 结账加上退菜的数量
					if (listCopy[i].returnQty) {
						listCopy[i].qty += Number(listCopy[i].returnQty);
						delete listCopy[i].returnQty;
					} else if (listCopy[i].returnfoodnumber) {
						listCopy[i].qty += Number(listCopy[i].returnfoodnumber);
					}

					delete listCopy[i].otherStatus;
					delete listCopy[i].index;
					delete listCopy[i].isNew;
				}

				return listCopy;
			},
			// 下单支付
			reqFn (numId, payType) {
				if (!this.isScan) {
					if (!this.promptMsg) {
            this.msgFn(2000, '输入的员工编号不存在', 'warning');
            return;
					}
					if (!this.tabName) {
            this.msgFn(2000, '请选择桌台', 'warning');
            return;
					}
					if (!this.memberCode) {
            this.msgFn(2000, '请输入服务员编号', 'warning');
            return;
					}
				}
				if (!this.eatNum) {
          this.msgFn(2000, '请输入就餐人数', 'warning');
          return;
				}

				var curClickInfo = JSON.parse(window.localStorage.getItem("curClickInfo"));
				curClickInfo.mealsNumber = parseInt(this.eatNum);
				window.localStorage.setItem("curClickInfo", JSON.stringify(curClickInfo));

				var time = this.showTime();//当前的时间
				var oldTableId = window.localStorage.getItem('oldTableId');
				var originaltableId = window.localStorage.getItem('originaltableId');
				var param = {
					'createTime': time,
          'model': this.model,
          'status': 1,
          "isFirstOrder": this.isFirstNum,
					//'orderItem': (this.memberInfo.memberId ? this.discountInfo : this.infoFn(time)),
					'orderItem': this.infoFn(time),
					"orderInfo": {
						"openid": this.$store.state.scanInfo.openid,
						"mealsNumber": this.eatNum,//订餐人数
						"tableId": oldTableId ? originaltableId : this.tabId,//转台的tableId
						"employeeId": this.memberCode,//服务员id
						"shopId": this.shopId,//门店id
						"remarks": this.remarks,//总单备注
						"nowTableId": oldTableId ? this.tabId : ''//桌台id
					}
				};

				// console.log(param);
        // return;// 下单的菜品
				var newCartList = JSON.parse(window.localStorage.getItem('newCartList'));
				/*if (newCartList[0] || oldTableId) {*/// 无新增菜品给提示，直接跳转，后加修改数量等，无法判断所以去除
					let loadingInstance = this.$loading({ fullscreen: true });
					this.$http.post(interfaceFn() + '/clientOrder',
          qs.stringify({
            jsonData: JSON.stringify(param)
          }), {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }).then((res) => {
			        	if (res.data.data == 'success') {
			        		this.msgFn(500, '下单成功', 'success');
				        	window.localStorage.removeItem("goSelectTab");
				        	window.localStorage.setItem("externalId", res.data.externalId);
			        		if (numId == 2) {
						        setTimeout(() => {
						        	loadingInstance.close();
						        	if (this.isScan) {//扫码点餐页面不跳转
						        		window.localStorage.removeItem("newCartList");
						        		//this.$router.push({path: "/room"});
						        		this.$router.push({path: "/details"});
						        	} else {//下单后跳转至桌台页面
						        		this.tableOperate();
						        	}
						        }, 1000);
			        		} else if (numId == 1) {
			        			setTimeout(() => {
			        				loadingInstance.close();
          							let manual = 0;
          							if (this.manualType == 0) {
          								manual = 0;
          							} else if (this.manualType == 1) {
          								manual = (this.manualOffer || 0);
          							} else if (this.manualType == 2) {
          								manual = (this.manualDiscount || 100) / 100;
          							}
          							if (payType >= 3) {
          								this.selectCurrency.originalAmount = this.otherPayMoney;
          								this.$store.state.currency = this.selectCurrency;
          							}
          							let uriParam = '?payMoney=' + this.payMoney + (payType ? '&payType=' + payType : '')
          								+ '&manualType=' + this.manualType + '&manual=' + manual + '&isFirstNum=' + this.isFirstNum;
          							this.$router.push({path: "/QrCode" + uriParam});
						        }, 1000);
			        		} else if (numId == 3) {
			        			if (payType == 0) this.msgFn(1500, '正在跳转至支付页面，请勿进行退出操作', 'success');
			        			loadingInstance.close();
			        			this.payImmediatelyFn(payType);
			        		}
			        	} else {
			        		loadingInstance.close();
			        		this.msgFn(1500, res.data.message, 'error');
			        	}
			        }).catch((err) => {
			        	loadingInstance.close();
			        	this.msgFn(1500, '服务器错误，请退出重试', 'error');
	          		});
				/*} else {
					if (numId == 1) {//下单后跳转至桌台页面
				        setTimeout(() => {
				        	this.$router.push({path: "/QrCode"});
				        }, 500);

	        		} else if (numId == 3) {
	        			this.msgFn (1500, '订单未修改无需重复提交', 'warning');
	        			this.$router.push({path: "/room"});
	        		} else {
	        			this.msgFn (1500, '订单未修改无需重复提交', 'warning');
	        			this.tableOperate();
						if (!this.isScan) this.$router.push({path: "/home"});
	        		}
				}*/
			},

			// 隐藏支付
			hidePay () {
				this.payShow = false;
				this.otherPay = false;
				this.otherOffPay = false;
			},

			// 其他支付显示隐藏
			otherPayFn () {
				let _this = this;
				this.otherPay = !this.otherPay;
				if (this.otherPay == false) {
					this.otherOffPay = false;
				} else {
					getCurrencyFn();
				}

				function getCurrencyFn () {
					_this.$http.get(interfaceFn()+'/shopService/getMoneyCategory?merchantId=' + window.localStorage.getItem("merchantId")).then((res) => {
						if (res.data.errcode == 0) {
							let storeList = res.data.storeList;
							_this.currencyList = storeList;
							if (storeList.length == 0) {
								_this.msgFn(2000, '暂无其他支付币种，可进行设置', 'warning');
							}
						}
					})
				}
			},

			// 其他货币支付
			morePayFn (n, i) {
				let pointCredit = 0;
				if (n == 3 || n == 4) {
					i = {};
					i.name = n == 3 ? '现金' : '银联';
					i.exchange = 1;
				} else if (n == 5 && this.shopSetInfo.isOpenPointCredit == 1) {
					pointCredit = Math.ceil(this.payMoney) * this.shopSetInfo.pointCredit;
					if (pointCredit > this.memberInfo.surplusIntegral) {
						this.msgFn(2000, '会员积分不足', 'warning');
						return;
					}
					i = {};
					i.name ='积分抵现';
					i.exchange = this.shopSetInfo.pointCredit;
					i.pointCredit = pointCredit;
				}

				this.otherPayWindow = true;
				i.payType = n;
				this.otherPayMoney = this.payMoney;
				if (n == 5) this.otherPayMoney = pointCredit;
				this.selectCurrency = i;
				this.selectCurrency.actualAmount = ((i.exchange * 10000 * this.payMoney) / 10000).toFixed(2);
				this.selectCurrency.change = ((this.selectCurrency.actualAmount * 100 - this.payMoney * 100) / 100).toFixed(2);

				if (this.manualType == 1) {
					// 手动优惠
					this.otherPayMoney = ((this.payMoney*100 - (this.manualOffer || 0)*100) / 100).toFixed(2);
					this.selectCurrency.actualAmount = this.otherPayMoney;

				} else if (this.manualType == 2) {
					// 手动折扣
					this.otherPayMoney = ((this.payMoney*(this.manualDiscount || 100)) / 100).toFixed(2);
					this.selectCurrency.actualAmount = this.otherPayMoney;
				}
			},
			// 金额输入计算找零
			otherPayMoneyFn (val) {
				this.selectCurrency.actualAmount = (this.selectCurrency.exchange * val).toFixed(2);
				let actualAmount = this.selectCurrency.actualAmount;
				let change = 0;
				if (this.manualType == 1) {
					// 手动优惠
					change = ((actualAmount * 100 - this.payMoney * 100 + (this.manualOffer || 0) * 100) / 100).toFixed(2);
				} else if (this.manualType == 2) {
					// 手动折扣
					let total = ((this.payMoney * (this.manualDiscount || 100)) / 100).toFixed(2);
					change = ((actualAmount * 100 - total * 100) / 100).toFixed(2);
				} else {
					change = ((actualAmount * 100 - this.payMoney * 100) / 100).toFixed(2);
				}
				this.selectCurrency.change = change;
			},


			// 扫码点餐n--1：立即支付，2：提交订单    payType--0：微信，1：会员
			scanFn (n, payType) {
				if (this.allCartList.length == 0) return;
				if (n == 1 && !payType) {
					this.payShow = true;
					this.discountMoney = 0;
					var teaFee = window.localStorage.getItem('fee');
					this.curClickInfo.teaFee = teaFee;
					this.teaFee = Math.floor(teaFee * this.allMoney) / 100;
					this.payMoney = ((this.teaFee * 100 + this.allMoney * 100) / 100).toFixed(2);
					return;
				}

				if (payType == 1) {
					// 门店验证码验证
					if (this.shopSetInfo.isSendVerificationCode == 1) {
						if (!this.code) {
							this.msgFn(2000, '验证码不能为空', 'warning');
              return;
						}
						if (this.code != this.verifyCode) {
							this.msgFn(2000, '验证码不正确', 'warning');
              return;
						}
					} else if (this.shopSetInfo.isSendVerificationCode == 0 && this.memberInfo.password) {
						if (!this.code && !this.password) {
							this.msgFn(2000, '请至少选择一种验证方式', 'warning');
              return;
						}
						if (this.password) {
							if (md5(this.password) != this.memberInfo.password) {
								this.msgFn(2000, '密码不正确', 'warning');
                return;
							}
						} else if (this.code) {
							if (this.code != this.verifyCode) {
								this.msgFn(2000, '验证码不正确', 'warning');
                return;
							}
						}
					}
				}
				if (n == 1) {
					var curClickInfo = JSON.parse(window.localStorage.getItem("curClickInfo"));
					if (curClickInfo.lowerCost > this.allMoney) {
						this.$confirm('该桌台最低消费为【￥' + curClickInfo.lowerCost + '】', '最低消费提示', {
							distinguishCancelAndClose: true,
							confirmButtonText: '确定',
							cancelButtonText: '加菜',
							type: 'warning'
						}).then(() => {}).catch((action) => {
							if (action === 'cancel') this.goBack();
						});
            return;
					}
					if (this.model == 0 || this.model == 3) {
						this.payImmediatelyFn(payType);
					} else {
						if (this.oldCartList.length > 0 && this.newCartList.length == 0) {
							this.payImmediatelyFn(payType);
						} else {
							this.goPay(3, payType);
						}
					}
				} else if (n == 2) {
					this.goPay(2, payType);
				}
			},

			/* 扫码点餐立即支付 */
			payImmediatelyFn (payType) {
				var _this = this;
				var curClickInfo = JSON.parse(window.localStorage.getItem("curClickInfo"));
				var random = Math.floor(Math.random() * 900 + 100);
				let requestData = {
					orderId: this.showTime(true) + random,//做随机的orderId，保证唯一性
					remarks: this.remarks,
					openid: this.$store.state.scanInfo.openid,
					merchantId: window.localStorage.getItem("merchantId"),
					shopId: window.localStorage.getItem("shopId"),
					tableId: this.$store.state.scanInfo.tab,
					orderBody: curClickInfo.title,// 桌台名称
					memberId: this.memberInfo.memberId,
					payType: payType,
					mealsNumber: this.eatNum,
					employeeId: 1,
					orderItem: []
				};

				var newCartList = JSON.parse(JSON.stringify(this.newCartList));
				var oldCartList = JSON.parse(JSON.stringify(this.oldCartList));
				oldCartList.filter(f => f.isAdd = 1);
				newCartList.filter(f => {
					f.isAdd = 0;
					if (f.remark == 0) {
						f.remark = '';
					} else {
						var remarkArr = [];
						f.remark.filter(k => {
							remarkArr.push('"' + k.name + '":' + k.price);
						})
						f.remark = "{" + remarkArr.join(',') + "}";
					}
				})

				var order = oldCartList.concat(newCartList);
				order.filter(f => f.price = f.allMoney);
				requestData.orderItems = JSON.stringify(order);
				// console.log(order);
        // return;//下单的菜品

				if (this.model == 0 || this.model == 3) {// 模式1 - 4下单支付
					this.$http.post(interfaceFn()+'/saobei/modelOneScanPay',
					qs.stringify(requestData), {
						headers: {
							"Content-Type": "application/x-www-form-urlencoded"
						}
					}).then((res) => {
						if (res.data.returnCode == 'ok') {
							if (payType == 0) {
								let href = res.data.url;
								let open = window.open('about:blank');
								if (open === null || typeof(open) === 'undefined') {
									window.localStorage.removeItem("newCartList");
									window.location.href = href;
									return;
								}
								setTimeout(() => {
									open.location = href;
									window.localStorage.removeItem("newCartList");
								}, 300);
							} else {
								window.localStorage.removeItem("newCartList");
								this.msgFn(2000, res.data.message, 'success');
								// if (this.model == 3) {
									let loadingMsg = this.$loading({ fullscreen: true });
									setTimeout(() => {
										loadingMsg.close();
										this.$router.push({path: '/ticket?orderCode=' + res.data.waimaiId});
									}, 1500);
								// } else {
								// 	this.$router.push({path: '/room'});
								// }
							}

						} else {
							this.msgFn(1500, res.data.message, 'warning');
						}
					}).catch(() => {
						this.msgFn(1500, '服务器错误，请稍后重试，或者联系服务员', 'error');
					});

				} else if (this.model == 1 || this.model == 2) {//模式2-3支付
					reqFn();
				}

				function reqFn () {
					_this.$http.post(interfaceFn()+'/saobei/modelOpenWapPay',
						qs.stringify({
							merchantId: window.localStorage.getItem("merchantId"),//商户id
							shopId: requestData.shopId,//门店id
							tableId: requestData.tableId,//桌台id
							totalFee: ((_this.memberInfo.memberId ? _this.payMoney : _this.teaFee) * 100),//服务费
							orderId: requestData.orderId,//订单号
							memberId: _this.$store.state.memberInfo.memberId,
							payType: payType,
							orderBody: _this.tabName,//桌台名称
							// jsonData: JSON.stringify(requestData)
					}), {
						headers: {
							"Content-Type": "application/x-www-form-urlencoded"
						}
					}).then((res) => {
						if (res.data.data == "ok" || res.data.returnCode == "ok") {
							if (payType == 0) {//payType--0：微信，1：会员
								var href = res.data.url;
								let open = window.open('about:blank');
								if (open === null || typeof(open) === 'undefined') {
									window.localStorage.removeItem("newCartList");
									window.location.href = href;
									return;
								}
								setTimeout(() => {
									open.location = href;
									window.localStorage.removeItem("newCartList");
								}, 300);
							} else if (payType == 1) {
								_this.msgFn(2000, '操作成功', 'success');
								// _this.$router.push({path: "/room"});
                _this.$router.push({path: '/ticket?orderCode=' + res.data.waimaiId});
							}

						} else {
							_this.msgFn(1500, res.data.url || res.data.message, 'warning');
						}
					}).catch(() => {
						_this.msgFn(1500, '服务器错误，请稍后重试，或者联系服务员', 'error');
					});
				}
			},


			showTime (type) {
				//获取当前时间
				var date = new Date();
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				month = zero(month);
				var day = date.getDate();
				day = zero(day);
				var hours = date.getHours(); //获取当前小时数(0-23)
				hours = zero(hours);
				var minutes = date.getMinutes(); //获取当前分钟数(0-59)
				minutes = zero(minutes);
				var seconds = date.getSeconds(); //获取当前秒数(0-59)
				seconds = zero(seconds);
				function zero (obj) {
					if (obj < 10) {
            obj = "0" + obj;
					}
          return obj;
				}
				var nowDate = '';
				if (type) {
					nowDate = year + month + day + hours + minutes + seconds;
				} else {
					nowDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
				}
				return nowDate;
			},

			// 桌台操作解锁
			tableOperate () {
				let num = 1;
				var curClickInfo = JSON.parse(window.localStorage.getItem('curClickInfo'));//获取当前点击的桌台信息
				let cartInfo = window.localStorage.getItem('cartInfo');
				if (cartInfo) {
					cartInfo = JSON.parse(cartInfo);
					num = cartInfo.orderInfo.mealsNumber;
				}
				let info = {
					shopId: window.localStorage.getItem('shopId'),
          tableId: window.localStorage.getItem('oldTableId') || curClickInfo.id,
          userId: JSON.parse(window.localStorage.getItem('userInfo')).id,
          operate: 2,// 0：单纯开台不点餐，1：锁台，2：解锁,3:清台
          remark: '解锁',
          mealsNumber: num,
				}
				let loadingInstance = this.$loading({ fullscreen: true });
				this.$http.post(interfaceFn()+'/shopTable/tableOperate',
        qs.stringify(info), {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }).then((res) => {
          loadingInstance.close();
          this.$router.push({path: "/home"});
        }).catch((err) => {
          loadingInstance.close();
        });
      },

			msgFn (time, msg, type) {
				this.$Message({
					duration: time,
          message: msg,
          center: true,
          type: type
				});
			}
		}
	}
</script>

<style scoped>
	@import "../../../static/css/pay.css";
</style>



// WEBPACK FOOTER //
// src/components/home/Pay.vue